import { Checkbox, Root } from "@radix-ui/react-checkbox"
import { cn } from "@/lib/utils"

export const Chip = ({ children, className, ...props }: React.ComponentPropsWithRef<typeof Checkbox>) => (
  <Root
    className={cn(
      "group bg-background data-[state=checked]:border-on-primary-surface data-[state=checked]:bg-primary-surface data-[state=checked]:text-on-primary-surface hover:bg-surface-hovered data-[state=checked]:hover:enabled:bg-primary-surface-hovered data-[state=checked]:focus:enabled:border-on-primary-surface flex items-center rounded-md border p-1.5 text-sm leading-5 font-medium",
      className,
    )}
    id="single-filter"
    {...props}>
    {children}
  </Root>
)
